export * from './logger';

export const stringToLower = (value?: string) => {
  return value?.toLowerCase()?.trim();
};
